/*
   본 소프트웨어는 관련 법률에 따라 보호되는 삼성의 지식재산 및 영업비밀 입니다. 본 소프트웨어를 권한 없이 사용하거나 삼성의 사전 서면 동의 없이 제3자에게 공개하는 행위는
   엄격히 금지되어 있으며 위반 시 귀하는 무단 사용 또는 비밀 유지 의무 위반에 대해 법적인 책임을 져야 합니다. This software is the intellectual
   property and confidential information of Samsung Electronics, Co., Ltd. (“Samsung”) protected by
   applicable laws. The unauthorized use or disclosure of the software to any third party without
   the prior written consent of Samsung is strictly prohibited, and you should be legally
  responsible for the unauthorized use or violation of confidentiality obligation.
*/
import { UID, IS_AUTH, ERROR_STATE, MENUS, LOCALE, PARAMS } from './mutation_types';

import api from '@/service';

const setUID = ({ commit }, data) => {
  commit(UID, data);
};

const setErrorState = ({ commit }, data) => {
  commit(ERROR_STATE, data);
};

const setIsAuth = ({ commit }, data) => {
  commit(IS_AUTH, data);
};

const setMenus = ({ commit }, data) => {
  commit(MENUS, data);
};

const setLocale = ({ commit }, data) => {
  commit(LOCALE, data);
};

const setParams = ({ commit }, data) => {
  commit(PARAMS, data);
};

const processResponse = (store, loginResponse) => {
  // http://devops.sdsdev.co.kr/confluence/pages/viewpage.action?pageId=76315514 code표 참고
  // console.log('processResponse:', loginResponse);
  switch (loginResponse.code) {
    case 'authOk':
      setUID(store, loginResponse.uid);
      setErrorState(store, { code: loginResponse.code });
      setIsAuth(store, true);
      break;
    case 'exception':
      setErrorState(store, { code: loginResponse.code, message: 'System error' });
      setIsAuth(store, false);
      break;
    default:
      // console.log(typeof loginResponse.code);
      if (typeof loginResponse.code === 'number') {
        loginResponse.code = String(loginResponse.code);
      }
      setErrorState(store, loginResponse);
      setIsAuth(store, false);
      break;
  }
};

export default {
  async login(store, { userId, password }) {
    const loginResponse = await api.login(userId, password);
    processResponse(store, loginResponse);
    return store.getters.getIsAuth;
  },
  async loginNewEpTray(store, { userInfo, key }) {
    const loginResponse = await api.loginNewEpTray(userInfo, key);
    processResponse(store, loginResponse);
    return store.getters.getIsAuth;
  },
  logout() {
    api.logout();
  },
  async getMenus(store, forceRemote = false) {
    const menuResponse = await api.getMenus(forceRemote);
    setMenus(store, menuResponse);
  },
  clearCache() {
    api.clearCache();
  },
  setLocale,
  setParams,
};



// WEBPACK FOOTER //
// ./src/vuex/actions.js